import { SocialAuthService } from '@abacritt/angularx-social-login';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthData } from 'app/shared/models/class/auth/auth-data';
import { AuthResponse } from 'app/shared/models/class/auth/auth-response';
import { AuthUser } from 'app/shared/models/class/auth/auth-user';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { IsAdminService } from '../isAdmin/is-admin.service';

import * as CryptoJS from 'crypto-js';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../data/data.service';
import { WishlistService } from '../wishlist/wishlist.service';
import { SetRouteService } from '../set-route/set-route.service';
import { BasketListService } from '../basketList/basket-list.service';
import { SocialUserSignUp, UserSignUp } from 'app/shared/models/class/user/user';
import { UiService } from '../ui/ui.service';
import { SessionBasketService } from '../session-basket/session-basket.service';
import { DOCUMENT } from '@angular/common';
import { AppComponent } from 'app/app.component';



@Injectable({
  providedIn: 'root'
})
export class AuthService {
  authChanged = new Subject<boolean>();
  isLoadingAuth = new Subject<boolean>();
  isAuthWithGoogle = new BehaviorSubject<boolean>(false);
  errorNoAccountGoogle = new Subject<any>();

  private identityApiUrl: string = environment.identityApiUrl;
  private apiUrl: string = environment.apiUrl;

  private tokenKey: string = environment.tokenKey;
  private rfTokenKey: string = environment.rfTokenKey;
  private tokenExpKey: string = environment.tokenExpKey;
  private afterLoginUrl = '/home';

  currentUser = new BehaviorSubject<InfosUser>(null);

  public get currentUserValue(): InfosUser {
    return this.currentUser.value;
  }
  acces_token: string;

  static readonly DEMO_THEME_CLASS = 'demo';
  static readonly DEMO_THEME_LIGHT = 'light';
  static readonly DEMO_THEME_DARK = 'dark';

  public theme: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    private jwtHelperSrv: JwtHelperService,
    private isAdminService: IsAdminService,
    private dialog: MatDialog,
    private dataService: DataService,
    private wishlistService: WishlistService,
    private sessionBasketService: SessionBasketService,
    private uiService: UiService,
    private socialAuthService: SocialAuthService,
    @Inject(DOCUMENT) private document: Document) {
    this.theme = this.document.documentElement.classList.contains(AuthService.DEMO_THEME_CLASS) ?
      AuthService.DEMO_THEME_DARK : AuthService.DEMO_THEME_LIGHT;
  }

  login(authData: AuthData, component?: string, action?: string): void {
    this.isLoadingAuth.next(true);
    const hashedPassword = this.cryptString(authData.password);
    const httpParams = new HttpParams()
      .append('username', authData.username)
      .append('password', hashedPassword)
      .append('grant_type', 'password')
      // .append('scope', 'LVHDFApi')
      .append('client_id', 'web');

    this.http.post<AuthResponse>(this.identityApiUrl + 'connect/token', httpParams)
      .subscribe(result => {
        this.saveToken(result.access_token, result.refresh_token, result.expires_in);
        this.authChanged.next(true);
        this.isAdminService.ifIsAdmin(this.getDecodedToken().role);
        this.currentUser.next(this.getDecodedToken());
        this.getWishListUser();
        this.getBasketListUser();
        this.dataService.titleWelcome$.next(`Bienvenue ${this.getDecodedToken().middle_name}`);
        this.isLoadingAuth.next(false);
        if (component === 'openDialog') { this.dialog.closeAll(); }
        if (action === "user") {
          this.router.navigate(['/home']);
        } else {
          this.router.navigate(['/admin']);
        }
        // this.router.navigate(['/admin']);
        // this.router.navigateByUrl(sessionStorage.getItem('route'));

        this.userIsDemo();

      }, error => {
        this.uiService.showSnackbar('Login ou mot de passe incorrect');
        this.isLoadingAuth.next(false);
      });
  }

  loginSocial(authTokenSocial: string, socialId: string, rs: string, email: string) {

    const httpParams = new HttpParams()
      .append('grant_type', 'social')
      // .append('scope', 'api offline_access')
      .append('client_id', 'web')
      .append('id', socialId)
      .append('type', rs)
      .append('token', authTokenSocial)
      .append('email', email);

    return this.http.post<AuthResponse>(`${environment.identityApiUrl}connect/token`, httpParams)
      .pipe(map(response => {
        if (response === null) {
        }

        this.saveToken(response.access_token, response.refresh_token, response.expires_in);

        const userInfos: InfosUser = this.jwtHelperSrv.decodeToken(response.access_token);

        this.authChanged.next(true);
        this.isAdminService.ifIsAdmin(this.getDecodedToken().role);
        this.currentUser.next(this.getDecodedToken());
        this.getWishListUser();
        this.getBasketListUser();
        this.dataService.titleWelcome$.next(`Bienvenue ${this.getDecodedToken().middle_name}`);

        this.dialog.closeAll();
        this.router.navigateByUrl(sessionStorage.getItem('route'));
        return this.setResponseLogin(response);
      }),
        tap(result => {
          this.saveToken(result.access_token, result.refresh_token, result.expires_in);
        }));
  }



  getWishListUser(): void {
    const userKey = this.getDecodedToken().sub;

    this.wishlistService.getWishList(userKey).subscribe({
      next: wishlist => this.dataService.myWishes.next(wishlist)
    });
  }

  getBasketListUser(): void {
    const userKey = this.getDecodedToken().sub;

    this.sessionBasketService.getBasketList(userKey).subscribe({
      next: basket => this.dataService.myShoppingBag.next(basket)
    });
  }

  // /**
  //  * Called if user forgot his password
  //  * Send email with link to reset password
  //  * @param username: username from request form
  //  */
  // requestPasswordReset(username: string): Observable<void> {
  //   const httpParams = new HttpParams().append('username', username);

  //   return this.http.post<void>(this.apiUrl + '/users/password-reset-request', httpParams);
  // }

  requestPasswordReset(email: string) {

    return this.http.get(this.apiUrl + '/users/password/' + email);
  }

  /**
   * Called if welcome link is expired or manually ask for new email in user management page
   * Send email with welcome link
   * @param username: username from email link or users list
   */
  requestPasswordInit(username: string): Observable<void> {
    const httpParams = new HttpParams()
      .append('username', username);

    return this.http.post<void>(this.apiUrl + '/users/password-init-request', httpParams);
  }

  updatePassword(resetData: { currentPassword: string, newPassword: string }): Observable<string> {
    const hashedCurrentPassword = this.cryptString(resetData.currentPassword);
    const hashedNewPassword = this.cryptString(resetData.newPassword);

    const httpParams = new HttpParams()
      .append('current_password', hashedCurrentPassword)
      .append('new_password', hashedNewPassword);

    return this.http.post<string>(this.apiUrl + '/users/password', httpParams)
      .pipe(
        tap(() => {
          this.afterPwdReset(resetData.newPassword);
        })
      );
  }

  resetPassword(userId: string, token: string, newPassword: string): Observable<void> {
    const hashedNewPassword = this.cryptString(newPassword);

    // Send data in body in place of http params to avoid mess in token serialisation due to special characters
    const body = {
      token,
      new_password: hashedNewPassword
    };

    return this.http.post<void>(`${this.apiUrl}/users/${userId}/password-reset`, body)
      .pipe(
        tap(() => {
          this.router.navigate(['/home']);
          this.uiService.showSnackbar('Mot de passe changé avec succès.')
        })
      );
  }

  refreshToken(): Observable<AuthResponse> {
    const refreshToken = localStorage.getItem(this.rfTokenKey);
    const httpParams = new HttpParams()
      .append('grant_type', 'refresh_token')
      // .append('scope', 'LVHDFApi')
      .append('client_id', 'web')
      .append('refresh_token', refreshToken);

    return this.http.post<AuthResponse>(this.identityApiUrl + 'connect/token', httpParams)
      .pipe(
        tap(result => {
          this.saveToken(result.access_token, result.refresh_token, result.expires_in);
          this.authChanged.next(true);
        })
      );
  }

  logout(prevUrl?: string): void {
    if (prevUrl) {
      this.afterLoginUrl = prevUrl;
    }
    if (this.isAuthWithGoogle.getValue()) {
      this.isAuthWithGoogle.next(false);
      this.socialAuthService.signOut()
    }

    localStorage.clear();
    this.authChanged.next(false);
    this.dataService.myWishes.next([]);
    this.router.navigateByUrl(sessionStorage.getItem('route'));
    this.dataService.titleWelcome$.next('Nautisme et plaisance en Hauts-de-France');
    if (sessionStorage.getItem('route')) {
      const universe = +sessionStorage.getItem('route')?.split('?')[1]?.split('&')[0]?.split('=')[1];
      universe === 5 ?
        (this.dataService.themeDemo$.next(true), this.selectDemoTheme()) :
        (this.dataService.themeDemo$.next(false), this.selectLightTheme());
    }

  }

  isAuth(): boolean {
    const decodedToken = this.getDecodedToken();

    if (!decodedToken || decodedToken.upd_pwd_req === true) {
      this.currentUser.next(null);
      this.refreshToken();
      return false;
    }

    this.currentUser.next(decodedToken);

    return !this.isTokenExpired();
  }

  getDecodedToken(): any {
    const token = this.jwtHelperSrv.tokenGetter();
    if (token) {
      const userInfos: InfosUser = this.jwtHelperSrv.decodeToken(token);
      return userInfos;
    }

    return null;
  }

  getUser(): AuthUser {
    const decodedToken = this.getDecodedToken();
    if (!decodedToken) {
      return null;
    }

    return new AuthUser(decodedToken.name);
  }

  isAuthorized(): boolean {
    const token = this.getDecodedToken();

    if (!token) {
      return false;
    }

    // authorised
    return true;
  }

  userIsDemo(): void {
    const user = this.getDecodedToken()?.name;
    if (user?.toLocaleLowerCase().includes('demo')) {
      this.dataService.themeDemo$.next(true);
      this.selectDemoTheme();
    } else {
      if (sessionStorage.getItem('route')) {
        const universe = +sessionStorage.getItem('route')?.split('?')[1]?.split('&')[0]?.split('=')[1];
        universe === 5 ?
          (this.dataService.themeDemo$.next(true), this.selectDemoTheme()) :
          (this.dataService.themeDemo$.next(false), this.selectLightTheme());
      }
    }

  }

  private selectDemoTheme(): void {
    this.document.documentElement.classList.add(AuthService.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(true);
    this.theme = AuthService.DEMO_THEME_DARK;
  }

  private selectLightTheme(): void {
    this.document.documentElement.classList.remove(AuthService.DEMO_THEME_CLASS);
    this.dataService.themeDemo$.next(false);
    this.theme = AuthService.DEMO_THEME_LIGHT;
  }

  private saveToken(accessToken: string, refreshToken: string, deadline: number): void {
    const tokenExpDate = new Date();
    tokenExpDate.setSeconds(tokenExpDate.getSeconds() + deadline);

    localStorage.setItem(this.tokenExpKey, tokenExpDate.toString());
    localStorage.setItem(this.tokenKey, accessToken);
    localStorage.setItem(this.rfTokenKey, refreshToken);
  }

  private afterPwdReset(newPassword: string): void {
    const decodedToken = this.getDecodedToken();

    if (decodedToken) {
      this.login({ username: decodedToken.name, password: newPassword });
    } else {
      this.logout();
    }
  }

  private isTokenExpired(): boolean {
    const tokenExpDate = new Date(localStorage.getItem(this.tokenExpKey));
    const now = new Date();
    return tokenExpDate < now;
  }

  public cryptString(stringTocrypt: string): string {
    return CryptoJS.SHA256(stringTocrypt).toString();

  }

  private setResponseLogin(response: AuthResponse): AuthResponse {
    localStorage.setItem(environment.tokenKey, response.access_token);
    localStorage.setItem(environment.rfTokenKey, response.refresh_token);
    // const user: InfosUser = this.jwtHelperSrv.decodeToken(response.access_token);
    // this.acces_token = response.access_token;
    // this.currentUser.next(user);
    return response;
  }
}
